import {inject, Injectable} from "@angular/core";
import {EntryViewerStateHandler} from "../handlers/state.handler";
import {EntryViewerPayBookingHandler} from "../handlers/pay-booking.handler";
import {Observable} from "rxjs";
import {EntryViewerNetworkHandler} from "../handlers/network.handler";
import {PAYMENT_METHOD} from "../../../../../shared/enums/payment-method.enum";
import {IPaymentResult} from "../../../payment/domain/interfaces/payment-storage.interface";

@Injectable({providedIn: 'root'})
export class EntryViewerViewModel {
  private readonly stateService = inject(EntryViewerStateHandler);
  private readonly networkService = inject(EntryViewerNetworkHandler);
  private readonly bookingPaymentHandler = inject(EntryViewerPayBookingHandler);

  readonly state$ = this.stateService.getViewState(
    this.networkService.isOffline$
  );

  payBookingAccount(paymentMethod: PAYMENT_METHOD): Observable<IPaymentResult> {
    return this.bookingPaymentHandler.payBookingAccount(paymentMethod);
  }
}
